module.exports = __webpack_public_path__ + "static/media/grb.49770d1e.png";